import icons from '@/assets/icons'
import React, { HTMLAttributes, ReactNode } from 'react'
import './index.less'

type SJCellProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  detail?: string | ReactNode
  indicator?: boolean
  mainPart?: 'left' | 'right'
  onClick?: () => void
}

const SJCell: React.FC<SJCellProps> = ({
  className,
  title,
  detail,
  mainPart = 'left',
  indicator = false,
  onClick,
  ...props
}) => {
  return (
    <div
      className={`sj-cell hoverClass ${className} sj-cell-main-${mainPart}`}
      onClick={onClick}
      {...props}
    >
      <span className="sj-cell-title oneline">{title}</span>
      {typeof detail === 'string' ? <span className="sj-cell-detail">{detail}</span> : detail}
      {indicator ? (
        <img className="sj-cell-indicator" src={icons.IconRight} alt="" />
      ) : (
        <div className="sj-cell-indicator"></div>
      )}
    </div>
  )
}

export default SJCell
